import {UntypedFormControl} from '@angular/forms';


export class PasswordValidatorOptions {

  constructor (public regex: RegExp, public name: string) {}
}

export function passwordValidator (options: Array<PasswordValidatorOptions>) {

  const validator = new PasswordValidator(options);

  return function validatePassword (control: UntypedFormControl) {
    return validator.validate(control.value);
  }

}

export class PasswordValidator {

  constructor (private options: Array<PasswordValidatorOptions>) {
  }

  public validate (value: string): any {

    if (!value) {
      return null;
    }

    const errors: any = {};
    this.options.forEach(object => {
      if (!object.regex.test(value)) {
        errors[object.name] = true;
      }
    });

    return Object.keys(errors).length > 0 ? errors : null;

  }

}